import api from 'api';
import type {
  AccountResourceType,
  ResourcePermissionsPayload,
  ResourcePermissionsUpdatePayload,
} from 'redux/modules/accounts.types';
export const resourcePermissionsApi = {
  get: (resource: AccountResourceType): Promise<ResourcePermissionsPayload> => {
    return api.get(`/${resource}/permissions`);
  },
  save: (payload: ResourcePermissionsUpdatePayload): Promise<ResourcePermissionsPayload> => {
    return api.post('permissions', { resource_permission: payload });
  },
};
